<!-- TODO - refacture popup za bookiranje -->
<div *ngIf="isInputVisible.termTypeSwitcher" class="d-flex justify-content-center">
    <div class="mf-term-type-switch mb-4">
        <div class="mf-term-type-switch-content p-2">
            <div class="row m-row--no-padding">
                <label class="col-4 col-form-label">
                    <strong i18n="@@94f1dc58e16591c0b9a9c8f47440e953784d714d">Termin s stranko</strong>
                </label>
                <div class="col-4 d-flex justify-content-center">
                    <span class="m-switch m-switch--outline m-switch--info">
                        <label>
                            <input
                                [(ngModel)]="isGenericTermSwitch"
                                (change)="changeTermType(); (isGenericTermSwitch != isGenericTermSwitch)"
                                type="checkbox"
                            />
                            <span></span>
                        </label>
                    </span>
                </div>
                <label class="col-4 col-form-label">
                    <strong i18n="@@2dedc43cd6e3332c23ef3e26e7086eafd4f0086b">Interni termin</strong>
                </label>
            </div>
        </div>
    </div>
</div>
<div class="d-flex justify-content-center">
    <div style="max-width: 500px" [ngClass]="{ 'mf-disabled-form': showCustomerDetailsForm }">
        <app-term-form
            #termForm
            [customerForTerm]="customerForTerm"
            [disableDateChange]="disableDateChange"
            [termComment]="termComment"
            [businessHours]="businessHours"
            [termType]="termType"
            [resRequestData]="resRequestData"
            [isCase]="isCase"
            (onOpenCustomerEditForm)="showCustomerEditForm($event)"
            (onOpenNewCustomerForm)="showNewCustomerForm($event)"
            (onOpenNewPayerForm)="showNewPayerForm($event)"
            (onClosePopup)="activeModal.close('Close click')"
        ></app-term-form>
    </div>

    <div *ngIf="showCustomerDetailsForm" [@expandCollapseWidth] [@expandCollapseHeight] style="max-width: 500px" class="pl-2 overflow-hidden">
        <app-customer-form
            #customerForm
            [customer]="customerForEdit"
            [newCustomer]="isNewCustomer"
            (onCancelCustomerEditForm)="cancelCustomerEdit($event)"
            (onSaveCustomer)="saveCustomer($event)"
        ></app-customer-form>
    </div>

    <div *ngIf="showPayerDetailsForm" [@expandCollapseWidth] [@expandCollapseHeight] style="max-width: 500px" class="pl-2 overflow-hidde">
        <app-acc-wid-cmn-payer-new-popup
            #partnerForm
            [enableModalActions]="false"
            [customer]="customerForEdit"
            [newCustomer]="isNewCustomer"
            (onCancel)="onCancelPayerDialog()"
            (onSave)="onSavePayer()"
        ></app-acc-wid-cmn-payer-new-popup>
    </div>
</div>
<div *ngIf="!showCustomerDetailsForm && !showPayerDetailsForm" class="modal-footer">
    <button
        (click)="activeModal.close('Close click')"
        type="button"
        tabindex="8"
        class="ml-auto btn m-btn--pill btn-warning m-btn m-btn--custom"
        [ngClass]="{ 'mr-auto': termType == reservationTypes.DRAFT }"
        i18n="@@cancel"
    >
        Prekliči
    </button>
    <button
        *ngIf="termType !== reservationTypes.DRAFT"
        (click)="submitDraftForm()"
        type="buttons"
        tabindex="6"
        ngbTooltip="Ustvari osnutek rezervacije"
        class="btn m-btn--pill btn-brand m-btn m-btn--custom"
        i18n-ngbTooltip="@@d457e4c4ee17ed7d818204d9ab461e344138883c"
        i18n="@@0c29b74549a37d5f01d6585a8717232d9746af88"
    >
        Osnutek
    </button>
    <button
        *ngIf="termType !== reservationTypes.DRAFT"
        (click)="submitForm()"
        type="buttons"
        tabindex="6"
        ngbTooltip="Ustvari novo rezervacijo"
        class="mr-auto btn m-btn--pill btn-accent m-btn m-btn--custom"
        i18n-ngbTooltip="@@86e180dbb4d29af768278706818327eabc710449"
        i18n="@@confirm"
    >
        Potrdi
    </button>
</div>
